import APIKeyList from "@/components/Common/APIKeyList/APIKeyList.vue";
import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";

const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

const defaultApiKey = { description: "" };

export default {
  name: "AdManagerAdmin",
  components: { APIKeyList },
  data: () => ({
    changedDescription: []
  }),
  async mounted() {
    await this.fetchData();
  },
  computed: {
    selectedPrincipal() {
      return this.$store.state.selectedPrincipal;
    },
    currentUser() {
      return this.$store.state.currentUser;
    },
    isAdmin() {
      return this.currentUser?.scopes?.includes("role:admin");
    },
    config() {
      return this.$store.state.adManagerConfig;
    },
    apiKeys() {
      return this.$store.state.adManagerApiKeys;
    }
  },
  methods: {
    async fetchData() {
      try {
        await this.$store.dispatch("getPrincipals");
        await this.$store.dispatch("getAdManagerConfig");
        await this.$store.dispatch("getAdManagerApiKeys");
      } catch (ex) {
        await this.$store.dispatch("createError", ex);
      }
    },
    async updateApiKeyDescription(index) {
      try {
        const headers = getTokenHeader();
        const response = await axios.put(
          `${env.ad_manager_api_client_url}apiKey/${this.apiKeys[index]._id}`,
          this.apiKeys[index],
          { headers }
        );
        if (response.status === 200) {
          await this.$store.dispatch(
            "createSuccess",
            "Erfolgreich gespeichert!"
          );
        }
      } catch (e) {
        await this.$store.dispatch("createError", e);
      }
    },
    async save() {
      const headers = getTokenHeader();
      try {
        if (this.changedDescription.length) {
          await this.changedDescription.asyncForEach(
            async changedDescription => {
              await this.updateApiKeyDescription(changedDescription);
            }
          );
          await this.$store.dispatch("getAdManagerApiKeys");
        }
        await axios.put(
          `${env.ad_manager_api_client_url}config/${this.selectedPrincipal?.id}/`,
          this.config,
          { headers }
        );
        await this.$store.dispatch("createSuccess", "Erfolgreich gespeichert");
        await this.$store.dispatch("getGlobalConfig");
      } catch (ex) {
        await this.$store.dispatch("createError", ex);
      }
    },
    async addApiKey() {
      try {
        const newApiKey = {
          apiKey: String.random(),
          config_ref: this.config._id,
          ...defaultApiKey
        };
        const headers = getTokenHeader();
        await axios.post(`${env.ad_manager_api_client_url}apiKey/`, newApiKey, {
          headers
        });
        await this.$store.dispatch("createSuccess", "Erfolgreich gespeichert!");
        await this.$store.dispatch("getAdManagerApiKeys");
      } catch (e) {
        await this.$store.dispatch("createError", e);
      }
    },
    async removeApiKey(key) {
      try {
        const isConfirmed = await this.$confirm(
          "Wollen Sie diesen API Key wirklich löschen?",
          confirmWarningConfig
        );
        if (isConfirmed) {
          const headers = getTokenHeader();
          await axios.delete(
            `${env.ad_manager_api_client_url}apiKey/${key._id}`,
            {
              headers
            }
          );
          await this.$store.dispatch(
            "createSuccess",
            "Erfolgreich gespeichert!"
          );
          await this.$store.dispatch("getAdManagerApiKeys");
        }
      } catch (error) {
        await this.$store.dispatch("createError", error);
      }
    },
    async copyApiKey(apiKey) {
      const clone = {
        ...apiKey,
        apiKey: String.random(),
        description: apiKey.description + " (Kopie)"
      };
      delete clone._id;
      delete clone.updatedBy;
      delete clone.createdBy;
      try {
        const headers = getTokenHeader();
        const response = await axios.post(
          `${env.ad_manager_api_client_url}apiKey/`,
          clone,
          {
            headers
          }
        );
        if (response.status === 201) {
          await this.$store.dispatch(
            "createSuccess",
            "Erfolgreich gespeichert!"
          );
          await this.$store.dispatch("getAdManagerApiKeys");
        } else {
          await this.$store.dispatch("createError");
        }
      } catch (e) {
        await this.$store.dispatch("createError");
      }
    },
    addChangedDescription(index) {
      if (!this.changedDescription.includes(index)) {
        this.changedDescription.push(index);
      }
    },
    async showApiKey(apiKey) {
      window
        .open(
          `${env.ad_manager_ad_zone_widget_api_url}eo-ad-zone.html?apiKey=${apiKey.apiKey}`,
          "_blank"
        )
        .focus();
    }
  }
};
